/** @format */

import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { rows } from "../../utils/Data";

import HeaderWrapper from "../../components/common/HeaderWrapper";
import CustomButton from "../../components/common/CustomButton";
import AttachmentsSection from "./Attachments";
import ProfileDetails from "./ProfileDetails";
// import AdminTable from "../Dashboard/ApplicationsPage/AdminApp/AdminTable";
import Table from "../Dashboard/ApplicationsPage/AnalystApp/Table";
import BankStatementAnalysis from "./BankStatementAnalysis";
import CreditAnalysis from "./CreditAanlysis";
import PredictionModelAnalysis from "./PredictionAnalysis";

const ProfilePage = () => {
  const [files, setFiles] = useState([]);
  const [activeTab, setActiveTab] = useState("loanHistory");
  const handleFileUpload = (event) => {
    const newFiles = [...files, event.target.files[0]];
    setFiles(newFiles);
  };
  const { applicantId } = useParams();

  const applicant = rows.find((row) => row.id === parseInt(applicantId));

  if (!applicant) {
    return <div>Applicant not found.</div>;
  }

  const attachments = [
    { name: "10mb_mac_identity_card.jpg", dateSubmitted: "2023-05-23" },
    { name: "bank_statement.pdf", dateSubmitted: "2023-05-21" },
    { name: "proof_of_residence.pdf", dateSubmitted: "2023-05-19" },
  ];

  const handleAddFile = () => {
    console.log("Add new file");
  };

  const { Name, Date, contact, email, bvn, address, nationalId } = applicant;

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div>
      <HeaderWrapper className="">
        <div className="flex flex-wrap w-full items-center justify-between -mt-1">
          <p>Applications &gt; {Name}</p>

          <CustomButton className="relative gap-2 text-xm">
            <span className="mr-5 text-sm">Make decision</span>
            <svg
              className="w-2 h-2  absolute top-1/2 right-1 transform -translate-y-1/2 pointer-events-none"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
            <div className="absolute right-0 mt-2 py-2 w-40 bg-white rounded-lg shadow-lg invisible">
              <ul>
                <li className="py-1 px-4 hover:bg-gray-100">Option 1</li>
                <li className="py-1 px-4 hover:bg-gray-100">Option 2</li>
                <li className="py-1 px-4 hover:bg-gray-100">Option 3</li>
              </ul>
            </div>
          </CustomButton>
        </div>
      </HeaderWrapper>
      <h1 className="text-3xl ml-4">{Name}</h1>
      <div className="flex flex-col md:flex-row ">
        {/* First Section */}
        <ProfileDetails applicant={applicant} />
        <div className="md:w-1/2">
          <AttachmentsSection />
        </div>
      </div>
      <div>
        <div className="mb-4 border-b border-gray-200">
          <ul
            className="flex flex-wrap -mb-px text-md  text-[#9E9E9E] font-medium text-center"
            id="myTab"
            data-tabs-toggle="#myTabContent"
            role="tablist"
          >
            <li className="mr-2" role="presentation">
              <button
                className={`inline-block p-4 rounded-t-lg focus:outline-none ${
                  activeTab === "loanHistory"
                    ? "text-black border-b-2 border-black"
                    : "text-[#9E9E9E] border-transparent"
                }`}
                id="loanHistory-tab"
                data-tabs-target="#loanHistory"
                type="button"
                role="tab"
                aria-controls="loanHistory"
                aria-selected={activeTab === "loanHistory"}
                onClick={() => handleTabChange("loanHistory")}
              >
                Loan History
              </button>
            </li>
            <li className="mr-2" role="presentation">
              <button
                className={`inline-block p-4 rounded-t-lg focus:outline-none ${
                  activeTab === "bankStatementAnalysis"
                    ? "text-black border-b-2 border-black"
                    : "text-[#9E9E9E] border-transparent"
                }`}
                id="bankStatementAnalysis-tab"
                data-tabs-target="#bankStatementAnalysis"
                type="button"
                role="tab"
                aria-controls="bankStatementAnalysis"
                aria-selected={activeTab === "bankStatementAnalysis"}
                onClick={() => handleTabChange("bankStatementAnalysis")}
              >
                Bank Statement analysis
              </button>
            </li>
            <li className="mr-2" role="presentation">
              <button
                className={`inline-block p-4 rounded-t-lg focus:outline-none ${
                  activeTab === "creditReportAnalysis"
                    ? "text-black border-b-2 border-black"
                    : "text-[#9E9E9E] border-transparent"
                }`}
                id="creditReportAnalysis-tab"
                data-tabs-target="#creditReportAnalysis"
                type="button"
                role="tab"
                aria-controls="creditReportAnalysis"
                aria-selected={activeTab === "creditReportAnalysis"}
                onClick={() => handleTabChange("creditReportAnalysis")}
              >
                Credit report analysis
              </button>
            </li>
            <li role="presentation">
              <button
                className={`inline-block p-4 rounded-t-lg focus:outline-none ${
                  activeTab === "predictionModelAnalysis"
                    ? "text-black border-b-2 border-black"
                    : "text-[#9E9E9E] border-transparent"
                }`}
                id="predictionModelAnalysis-tab"
                data-tabs-target="#predictionModelAnalysis"
                type="button"
                role="tab"
                aria-controls="predictionModelAnalysis"
                aria-selected={activeTab === "predictionModelAnalysis"}
                onClick={() => handleTabChange("predictionModelAnalysis")}
              >
                Prediction model analysis
              </button>
            </li>
          </ul>
        </div>

        <div id="myTabContent">
          <div
            className={`rounded-lg ${
              activeTab === "loanHistory" ? "block" : "hidden"
            }`}
            id="loanHistory"
            role="tabpanel"
            aria-labelledby="loanHistory-tab"
          >
            <Table arrays={rows} showActions={false} />
            {/* <AdminTable arrays={rows} showActions={false} /> */}
          </div>
          <div
            className={`p-4  ${
              activeTab === "bankStatementAnalysis" ? "block" : "hidden"
            }`}
            id="bankStatementAnalysis"
            role="tabpanel"
            aria-labelledby="bankStatementAnalysis-tab"
          >
            <BankStatementAnalysis />
          </div>
          <div
            className={`p-4  ${
              activeTab === "creditReportAnalysis" ? "block" : "hidden"
            }`}
            id="creditReportAnalysis"
            role="tabpanel"
            aria-labelledby="creditReportAnalysis-tab"
          >
            <CreditAnalysis />
          </div>
          <div
            className={`p-4 rounded-lg  ${
              activeTab === "predictionModelAnalysis" ? "block" : "hidden"
            }`}
            id="predictionModelAnalysis"
            role="tabpanel"
            aria-labelledby="predictionModelAnalysis-tab"
          >
            <PredictionModelAnalysis />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
